var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"deadline-timer-container"},[_c('div',{staticClass:"deadline-timer"},[_c('span',[_vm._v(_vm._s(_vm.timeStamp.minutes))]),_c('span',[_vm._v(":")]),_c('span',[_vm._v(_vm._s(_vm.timeStamp.seconds))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }